import { render, staticRenderFns } from "./WorkIconInspection.vue?vue&type=template&id=5dd5a7ea"
import script from "./WorkIconInspection.vue?vue&type=script&lang=js"
export * from "./WorkIconInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports